import React from 'react'

interface TableBodyProps {
  className?: string
}

export const TableBody: React.FC<TableBodyProps> = props => <div {...props} />
